import PropTypes from "prop-types";
import { Toolbar, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Header = ({ handleLeftDrawerToggle }) => {
  return (
    <Toolbar
      sx={{
        width: "100%",
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Left side - menu toggle */}
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleLeftDrawerToggle}
        sx={{
          mr: 2,
          display: { md: "none" }, // visible only on mobile/tablet
        }}
      >
        <MenuIcon />
      </IconButton>

      {/* Title */}
      <Typography
        variant="h6"
        noWrap
        component="div"
        sx={{
          flexGrow: 1,
          fontWeight: 600,
          color: "white",
        }}
      >
        VermontKidsData.org Administrative Dashboard
      </Typography>
    </Toolbar>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;


